import React, { FunctionComponent, useEffect, useState } from 'react';
import LoginLeftSection from 'components/loginLeftSection/LoginLeftSection';
import InputField from 'components/textField/InputField';
import Button from 'components/button/Button';
import Styles from './EmailVerification.module.scss';
import RegisterStyles from 'views/register/Register.module.scss';
import { useHistory } from 'react-router';
import { validateEmail } from 'helpers/utils';

interface EmailVerificationProps {
  verifyEmail: Function;
  isEmailVerified: boolean;
  isLoading: boolean;
  error: string;
}

const EmailVerification: FunctionComponent<EmailVerificationProps> = (props: EmailVerificationProps) => {
  const { verifyEmail, isEmailVerified, isLoading, error } = props;
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [isVerified] = useState(isEmailVerified);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const handleValidateEmail = () => {
    if (JSON.parse(localStorage.getItem('userObj') || '').email !== email) {
      setEmailError(true);
      return;
    } else {
      if (validateEmail(email)) {
        setEmailError(false);
        if (!isVerified) {
          verifyEmail({ email });
        }
      } else {
        setEmailError(true);
      }
    }
  };

  useEffect(() => {
    if (isEmailVerified) {
      history.push('/registration/otp');
    }
  }, [isEmailVerified]);

  useEffect(() => {}, [error]);

  useEffect(() => {
    if (email.length === 0) {
      setEmailError(false);
    }
  }, [email]);

  useEffect(() => {
    if (email === null) history.push('/registration');
    if (email) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [email]);

  useEffect(() => {
    setEmail(JSON.parse(localStorage.getItem('userObj') as string).email);
  }, []);

  return (
    <section className={Styles.customContainer}>
      <div className={Styles.leftSectionWrapper}>
        <LoginLeftSection />
      </div>
      <div className={Styles.rightSectionWrapper}>
        <div className={Styles.loginArea}>
          <div className={Styles.formContent}>
            <div className={Styles.stepBlock}>
              <div className={Styles.stepLabel}>STEP 2</div>
              <div className={Styles.stepSubtitle}>Confirm your email address</div>
            </div>

            <div className={Styles.tagLine}>
              <span className={Styles.tagLineFirst}>To proceed in signing up, please confirm</span>
              <br />
              your email address first.
            </div>

            <div className={Styles.inputWrapper}>
              <InputField
                type="email"
                placeholder="Confirm email address"
                value={email}
                handleChange={(e: string) => setEmail(e)}
                cssClass={RegisterStyles.registerField}
              />
              {emailError && <div className={Styles.error}>Invalid Email</div>}
              {error && <div className={Styles.error}>{error}</div>}
            </div>

            <div className={Styles.confirmEmailBtn}>
              <Button
                clickHandler={handleValidateEmail}
                showLoading={isLoading}
                label="CONFIRM"
                disabled={disabled}
                cssClass={RegisterStyles.authPrimaryBtn}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmailVerification;
